<template>
  <div class="ab-pro-fixed">
    <div class="viz-header-compact" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula-chip" v-latex>$Δφ = (q/ħ) ∮ A · dl$</div>
    </div>

    <div class="main-layout vertical">
      <div class="simulation-stage dark-stage">
        <div class="hud-panel">
          <div class="hud-item cyan">
            <label>磁矢势 A 路径积分</label>
            <span class="val">{{ phaseShift.toFixed(2) }} rad</span>
          </div>
          <div class="hud-item orange">
             <label>干涉条纹平移</label>
             <span class="val">{{ (phaseShift * 10).toFixed(1) }} px</span>
          </div>
        </div>

        <svg width="100%" height="240" viewBox="0 0 500 240" preserveAspectRatio="xMidYMid meet">
          <!-- 无磁场区域的无限长螺线管 (截面) -->
          <circle cx="200" cy="120" r="30" fill="#334155" stroke="#475569" stroke-width="2" />
          <text x="200" y="125" text-anchor="middle" fill="#fff" font-size="10">螺线管 (B=0, A≠0)</text>
          
          <!-- 磁矢势 A 的环道演示 -->
          <circle cx="200" cy="120" r="60" fill="none" stroke="rgba(6, 182, 212, 0.2)" stroke-width="1.5" stroke-dasharray="4,2">
             <animateTransform attributeName="transform" type="rotate" from="0 200 120" to="360 200 120" dur="5s" repeatCount="indefinite" />
          </circle>

          <!-- 电子波导路径 (两路干涉) -->
          <path d="M 50,120 Q 125,40 200,40 Q 275,40 350,120" fill="none" stroke="#3b82f6" stroke-width="2" stroke-dasharray="2,2" />
          <path d="M 50,120 Q 125,200 200,200 Q 275,200 350,120" fill="none" stroke="#f43f5e" stroke-width="2" stroke-dasharray="2,2" />

          <!-- 干涉条纹屏 (动态偏移) -->
          <rect x="420" y="40" width="10" height="160" fill="#1e293b" />
          <g :transform="`translate(435, ${120 + phaseShift * 15})`">
             <rect v-for="i in 10" :key="i" x="0" :y="-80 + i*16" width="30" height="4" fill="#fbbf24" opacity="0.6" />
          </g>
        </svg>

        <div class="physics-caption">
          <strong>物理规律：</strong>即使在电子路径完全经过磁场强为零（$B=0$）的区域，只要该区域被磁矢势（$A$）包围，不同路径的波函数相位仍会发生相对偏移。这证明了<strong v-latex>磁矢势 $A$ 比磁场 $B$ 具有更本质的物理地位</strong>。
        </div>
      </div>

      <div class="compact-controls">
        <div class="control-card">
           <div class="label-row"><span class="label">调节螺线管磁通量 (改变 A 路径积分)</span></div>
           <el-slider v-model="flux" :min="0" :max="3.14" :step="0.01" size="small"></el-slider>
        </div>
        
        <div class="discovery-card-discovery" v-latex>
           <i class="el-icon-link"></i>
           <p><strong>实战物理：</strong>由于这种拓扑相位，AB 效应在纳米环、量子比特计算中至关重要。<strong>观察：</strong>调节滑块，观察干涉条纹的上下平移。注意电子路径（蓝色/红色）从未进入螺线管内部。这展示了<strong>量子力学的非定域性</strong>。
           </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default { props: { knowledgePoint: String },
  name: 'AharonovBohmEffectViz',
  data() {
    return {
      flux: 1.57
    }
  },
  computed: {
    phaseShift() { return this.flux; }
  }
}
</script>

<style scoped lang="scss">
@import "./PhysicsCommon.scss";
.ab-pro-fixed { flex: 1; display: flex; flex-direction: column; gap: 8px; height: 100%; overflow: hidden; }
</style>
